import React from 'react';
import MotorList from './motor-list';
import { useAppSelector } from '../../../store/hooks/StoreHooks';
import MotorPerformance from './motor-performance';
import FluidVelocity from './fluid-velocity';
import Sensor from './sensor';
import RecommendedParameters from '../motor/recommended-parameters';
import Alert from '../../../assets/icons/Alert';

const Motor: React.FC = () => {

    const { MotorperformanceList, SelectedMotor, fluidVelocity, FluidVelocityPostMotor } = useAppSelector(state => state?.motor);
    const { tab1Input } = useAppSelector(state => state?.tubing);
    return (
        <div className='flex flex-col justify-center item-center w-full h-full gap-[16px] py-5'>
            {MotorperformanceList[0]?.motorLoad > 100 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Required load exceeds motor capacity
                    </p>
                </div>
            )}
            {MotorperformanceList[0]?.opeatngTemp > (SelectedMotor?.maxOperatingTemp ?? 0) && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Operating Temp. is higher than Max. Operating temperature of motor
                    </p>
                </div>
            )}
            {tab1Input?.hiddenWthrMotrShrd == '0' && +fluidVelocity < 1 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor is not sufficient
                    </p>
                </div>
            )}
            {tab1Input?.hiddenWthrMotrShrd == '0' && +fluidVelocity > 12 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor exceeds the maximum limit
                    </p>
                </div>
            )}
            {tab1Input?.hiddenWthrMotrShrd == '1' && tab1Input?.hiddenMotrShrdOD == '' && +fluidVelocity < 1 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor is not sufficient
                    </p>
                </div>
            )}
            {tab1Input?.hiddenWthrMotrShrd == '1' && tab1Input?.hiddenMotrShrdOD == '' && +fluidVelocity > 12 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor exceeds the maximum limit
                    </p>
                </div>
            )}
            {tab1Input?.hiddenMotrShrdOD != '' && tab1Input?.hiddenMotrShrdWght == '' && +fluidVelocity < 1 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor is not sufficient
                    </p>
                </div>
            )}
            {tab1Input?.hiddenMotrShrdOD != '' && tab1Input?.hiddenMotrShrdWght == '' && +fluidVelocity > 12 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor exceeds the maximum limit
                    </p>
                </div>
            )}
            {tab1Input?.hiddenMotrShrdWght != '' && +FluidVelocityPostMotor < 1 && (+FluidVelocityPostMotor > 0) && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor is not sufficient
                    </p>
                </div>
            )}
            {tab1Input?.hiddenMotrShrdWght != '' && +FluidVelocityPostMotor > 12 && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Fluid velocity past motor exceeds the maximum limit
                    </p>
                </div>
            )}
            {tab1Input?.hiddenMotrShrdWght != '' && +FluidVelocityPostMotor <= 0 && tab1Input?.hiddenWthrMotrShrd === '1' && (
                <div className='flex ml-4 mr-4 mb-4 p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
                    <Alert className='mr-2' />
                    <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                        Choosen shroud is smaller than the selected motor
                    </p>
                </div>
            )}

            <MotorList />
            <MotorPerformance />
            <FluidVelocity />
            <Sensor />
            {/* <RecommendedParameters /> */}
        </div>
    );
};

export default Motor;
